import React, { Component } from 'react';
import { post } from 'axios';
import '../css/AdminUpload.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import  {  Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';




export default class AdminUpload extends Component
{
   constructor(props) {
      super(props);
      this.state ={
        category: '',
        title: '',
        description: '',
        price:'',
        availability:false,
        image: '',
        tokopedia: '',
        shopee: '',
        bukalapak: '',
        isHacker: false
      }
      this.onFormSubmit = this.onFormSubmit.bind(this)
      this.onChangeCategory = this.onChangeCategory.bind(this)
      this.onChangeTitle = this.onChangeTitle.bind(this)
      this.onChangeDesc = this.onChangeDesc.bind(this)
      this.onChangePrice = this.onChangePrice.bind(this)
      this.onChangeAvail = this.onChangeAvail.bind(this)
      this.onChange = this.onChange.bind(this)
      this.fileUpload = this.fileUpload.bind(this)
      this.onChangeTokopedia = this.onChangeTokopedia.bind(this)
      this.onChangeShopee = this.onChangeShopee.bind(this)
      this.onChangeBukalapak = this.onChangeBukalapak.bind(this)
    }

    componentDidMount() {
        if (localStorage.getItem('token') !== localStorage.getItem('existToken') || localStorage.getItem('existToken') === null){
            this.setState({ 
                isHacker:true
            });
        }
    }

    onChangeCategory(e) {
        this.setState ({
          category: e.target.value
        })
    }
    onChangeTitle(e) {
        this.setState ({
            title: e.target.value
        })
    }
    onChangeDesc(e) {
        this.setState ({
            description: e.target.value
        })
    }
    onChangePrice(e) {
        this.setState ({
            price: e.target.value
        })
    }
    onChangeAvail(e) {
        this.setState ({
            availability: e.target.checked
        })
    }
    onChangeTokopedia(e) {
        this.setState ({
            tokopedia: e.target.value
        })
    }
    onChangeShopee(e) {
        this.setState ({
            shopee: e.target.value
        })
    }
    onChangeBukalapak(e) {
        this.setState ({
            bukalapak: e.target.value
        })
    }
    onChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length)
                return;
        this.createImage(files[0]);
    }
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({
          image: e.target.result
        })
      };
      reader.readAsDataURL(file);
    }
    onFormSubmit(e){
        e.preventDefault();
        let category = this.state.category;
        let title = this.state.title;
        let description = this.state.description;
        let price = this.state.price;
        let availability = '0';
        if (this.state.availability) {
            availability = '1';
        } 
        let image = this.state.image;
        let tokopedia = this.state.tokopedia;
        let shopee = this.state.shopee;
        let bukalapak = this.state.bukalapak;
        this.fileUpload(category,title,description,price,availability,image,tokopedia,shopee,bukalapak);
        e.target.reset();
      }
    fileUpload(category,title,description,price,availability,image,tokopedia,shopee,bukalapak){
      const url = "https://ikaemerce.faisalhakim.com/apilaravel/public/api/products";
      const formData = {category: category, title: title, description: description, price: price, availability:availability, filename: image,link_tokopedia:tokopedia, link_shopee:shopee, link_bukalapak: bukalapak}
      return  post(url, formData)
              .then(response => toast("Successfully added"))
              .then(
                this.setState ({
                    category: '',
                    title: '',
                    description: '',
                    price:'',
                    availability:false,
                    image: '',
                    tokopedia: '',
                    shopee: '',
                    bukalapak: ''
                })
              )
              .catch(function (error) {
                if (error.response) {
                  // Request made and server responded
                  toast("Failed, "+error.response.data.message);
                } else if (error.request) {
                  // The request was made but no response was received
                 toast("Failed, "+error.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  toast('Failed, ', error.message);
                }
            
              });
    }
  
   render()
   {
      return (
        <div className="adminUpload container">
          {this.state.isHacker ? <Redirect to="/login" /> : ""}
          <form onSubmit={this.onFormSubmit}>
            <h1>IKAEMERCE Product New</h1>
            <table className="mx-auto form-group">
              <tbody>
                <tr>
                  <td>Category</td>
                  <td className="tableSpace">:</td>
                  <td>
                    <input
                      type="text"
                      name="category"
                      className="form-control"
                      value={this.state.category}
                      onChange={this.onChangeCategory}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Title</td>
                  <td className="tableSpace">:</td>
                  <td>
                    <input
                      type="text"
                      name="title"
                      className="form-control"
                      value={this.state.title}
                      onChange={this.onChangeTitle}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td className="tableSpace">:</td>
                  {/* <td><input type="text"  value={this.state.description} onChange={this.onChangeDesc}/></td> */}
                  <td>
                    <textarea
                      value={this.state.description}
                      name="description"
                      className="form-control"
                      onChange={this.onChangeDesc}
                      rows="4"
                      cols="50"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Price</td>
                  <td className="tableSpace">:</td>
                  <td>
                    <input
                      type="text"
                      name="price"
                      className="form-control"
                      value={this.state.price}
                      onChange={this.onChangePrice}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Availability</td>
                  <td className="tableSpace">:</td>
                  <td>
                    <input
                      name="availability"
                      type="checkbox"
                      checked={this.state.availability}
                      onChange={this.onChangeAvail}
                    />
                  </td>
                </tr>
                <tr>
                  <td>File</td>
                  <td className="tableSpace">:</td>
                  <td>
                    <input type="file" className="form-control-file" onChange={this.onChange} />
                  </td>
                </tr>
                <tr>
                  <td>Link Tokopedia</td>
                  <td className="tableSpace">:</td>
                  <td>
                    <input
                      type="text"
                      name="tokopedia"
                      className="form-control"
                      value={this.state.tokopedia}
                      onChange={this.onChangeTokopedia}
                      placeholder="Keep this empty, if you don't have Tokopedia link"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Link Shopee</td>
                  <td className="tableSpace">:</td>
                  <td>
                    <input
                      type="text"
                      name="shopee"
                      className="form-control"
                      value={this.state.shopee}
                      onChange={this.onChangeShopee}
                      placeholder="Keep this empty, if you don't have Shopee link"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Link Bukalapak</td>
                  <td className="tableSpace">:</td>
                  <td>
                    <input
                      type="text"
                      name="bukalapak"
                      className="form-control"
                      value={this.state.bukalapak}
                      onChange={this.onChangeBukalapak}
                      placeholder="Keep this empty, if you don't have Bukalapak link"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <button type="submit" className="btn btn-sm btn-primary mx-auto">
              Submit
            </button>
            &emsp;
            <Link to="/admin" className="btn btn-sm btn-danger">
              {" "}
              Back{" "}
            </Link>
          </form>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      );
   }
}